import { useContext } from 'react';
import { SnacksContext } from 'containers/SnacksProvider';

const withSnacks = Wrapped => {
  const WithSnacks = props => {
    const snacks = useContext(SnacksContext);
    return <Wrapped {...props} {...snacks} />;
  };
  WithSnacks.displayName = `withSnacks(${Wrapped.displayName || Wrapped.name || 'Component'})`;
  return WithSnacks;
};

export default withSnacks;
